import React from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { useDrone } from '../context/DroneContext';
import { Navigation, UserData } from '../context';
import { createAd, sendEvent } from '../../../api';
import VBDropdown from '@virkesborsen/vb-js-commons/lib/components/new/vbDropdown';
import { useSubscription } from '../context/SubscriptionCheckoutContext';

import { Chip } from '../aragon/components/Chip';

import ArbonicsDialog from './ArbonicsDialog/ArbonicsDialog';
import { useModalCloseOnEsc } from '../utils';

export default function MainNav() {
    const navContext = React.useContext(Navigation);
    const { openCheckout } = useSubscription();
    const userContext = React.useContext(UserData);
    const [offcanvas, setOffcanvas] = React.useState(false);
    const [createAdModal, setCreateAdModal]  = React.useState({show: window.location.href.includes("#salj-virke")});
    const [arbonicsDialogVisible, setArbonicsDialogVisible] = React.useState(window.location.href.includes("#co2-interest"));

    const setHistory = (id) => {
        if(history.state?.comp != id) {
            history.pushState({comp: id}, '', '')
        }
    }

    useModalCloseOnEsc(createAdModal.show, () => setCreateAdModal({show: false}))

    const menuButton = (id, label, icon) => {
        return <div id={'menu' + id} role='button' onClick={() => {navContext.setView({comp: id}); setOffcanvas(false); setHistory(id)}} className={`d-flex align-items-center ${navContext.view?.comp == id ? 'bg-supp-forest-green white' : 'supp-forest-green hover-bg-supp-forest-green-100'} rounded mt-1 ps-2 py-1`}>
            <span className="d-flex align-items-center">
                <img src={`${Window.static_path}${icon}`} className={`${navContext.view?.comp == id ? 'white-filter' : 'supp-forest-green-filter'} `} height='25px' width='25px' />
                <span className="ms-2">{label}</span>
            </span>
        </div>
    }

    const menuLink = (url, label, icon) => {
        return <a href={url} className="d-flex align-items-center supp-forest-green hover-bg-supp-forest-green-100 rounded mt-1 ps-2 py-1">
            <img src={`${Window.static_path}${icon}`} className="supp-forest-green-filter" height={label == "Skoglig rådgivning"? "20px":"25px"} width={label == "Skoglig rådgivning"? "20px":"25px"} />
            <span className="ms-2">{label}</span>
        </a>
    }

    const sellerModal = () => {
        return <p role='button' onClick={() => {setCreateAdModal({show: true}); mixpanel.track("salja_virke_fe", { "source": "min-skog_main_nav" });}} className="d-flex align-items-center supp-forest-green hover-bg-supp-forest-green-100 rounded mt-1 ps-2 py-1 mb-0" style={{}}>
            <img src={`${Window.static_path}img/icons/tree-money.svg`} className="supp-forest-green-filter" height="25px" width="25px" />
            <span className="ms-2">Sälj virke</span>
        </p>
    }

    const arbonicsMenuItem = () => {
        const handleArbonicsClick = () => {
            setArbonicsDialogVisible({show: true})

            sendEvent('co2_open_modal', {source:'main_nav'})
            gtag("event", "co2_open_modal", {
                method: "site"
              });

            setOffcanvas(false)
        }

        return  <p role='button' onClick={handleArbonicsClick} className="d-flex align-items-center supp-forest-green hover-bg-supp-forest-green-100 rounded mt-1 ps-2 py-1 mb-0">
            <img src={`${Window.static_path}img/icons/co2_cloud.svg`} className="supp-forest-green-filter" height="25px" width="25px" />
            <span className="ms-2 me-2">Kolkrediter</span>
            
        </p>
    }


    const droneMenuItem = () => {
        const id = 'drone'
        
        return  <div id={'menu' + id} role='button' onClick={() => {navContext.setView({comp: id}); setOffcanvas(false); setHistory(id)}} className={`d-flex align-items-center ${navContext.view?.comp == id ? 'bg-supp-forest-green white' : 'supp-forest-green hover-bg-supp-forest-green-100'} rounded mt-1 ps-2 py-1`}>
            <span className="d-flex align-items-center ">
                <img src={`${Window.static_path}img/icons/drone.svg`} className={`${navContext.view?.comp == id ? 'white-filter' : 'supp-forest-green-filter'} `} height='25px' width='25px' />
                <span className="mx-2">Drönaranalys</span>
                <Chip type="plus" />
            </span>
        </div>
    }
    
    const dfrMenuItem = () => {
        const id = 'overvakning'
        
        return  <div id={'menu' + id} role='button' onClick={() => {navContext.setView({comp: id}); setOffcanvas(false); setHistory(id)}} className={`d-flex align-items-center ${navContext.view?.comp == id ? 'bg-supp-forest-green white' : 'supp-forest-green hover-bg-supp-forest-green-100'} rounded mt-1 ps-2 py-1`}>
            <span className="d-flex align-items-center">
                <img src={`${Window.static_path}img/icons/satelite.svg`} className={`${navContext.view?.comp == id ? 'white-filter' : 'supp-forest-green-filter'} `} height='25px' width='25px' />
                <span className="mx-2">Skogsövervakning</span>
                <Chip type="beta" />
            </span>
        </div>
    }

     const pricingMenuItem = () => {
        const id = 'pricing'
        
        return  <div id={'menu' + id} role='button' onClick={() => {navContext.setView({comp: id}); setOffcanvas(false); setHistory(id)}} className={`d-flex align-items-center ${navContext.view?.comp == id ? 'bg-supp-forest-green white' : 'supp-forest-green hover-bg-supp-forest-green-100'} rounded mt-1 ps-2 py-1`}>
            <span className="d-flex align-items-center">
                <img src={`${Window.static_path}img/icons/suitcase-star.svg`} className={`${navContext.view?.comp == id ? 'white-filter' : 'supp-forest-green-filter'} `} height='25px' width='25px' />
                <span className="mx-2">Priser & paket</span>
            </span>
        </div>
    }

    const menuItems = () => {
       
        const userHasAdsOrBids = (userContext?.userData?.ads?.ads?.length > 0 || userContext?.userData?.ads?.bids?.lost?.length > 0 || userContext?.userData?.ads?.bids?.on_going?.length > 0 || userContext?.userData?.ads?.bids?.won?.length > 0 || userContext?.userData?.ads?.bids?.not_sold?.length > 0 || (userContext?.userData?.child_accounts && Object.keys(userContext?.userData?.child_accounts).length > 0))
         
        return <div className="d-flex flex-column justify-content-between h-100 py-3 py-lg-4 n-fs-6">
            <div className="d-flex flex-column align-items-center text-center w-100">
                <a className='mb-3' href="/">
                    <img src={`${Window.static_path}img/treebula/logo.svg`}  className="d-block supp-forest-green-filter" height="30" />
                </a>
        
                <div className='w-100 mb-4'>
                    <p className='supp-forest-green text-start n-fs-7 ms-2 mb-0'>Min skog</p>

                    {menuButton('karta', 'Karta', 'img/icons/karta.svg')}
                    {menuButton('overblick', 'Överblick', 'img/icons/overview.svg')}                  
                </div>
                
                <div className='w-100 mb-4'>
                    <p className='supp-forest-green text-start n-fs-7 ms-2 mb-0'>Tjänster</p>
                    {menuLink('/virkespriser/', 'Jämför virkespriser', 'img/icons/labels-trade.svg')}
                    {sellerModal()}
                    {dfrMenuItem()}
                    {pricingMenuItem()}
                    {Window.user_data.isPremium && droneMenuItem()}
                    {arbonicsMenuItem()}
                    {menuLink(Window.user_data.isPremium ? '/redirect-book-meeting/' :'/skoglig-radgivning/','Skoglig rådgivning','img/icons/headset.svg')}
                    {userHasAdsOrBids && menuButton('annonser', 'Mina annonser', 'img/icons/item-list.svg')}
                    {menuLink('/kunskapscentrum/nyheter/','Marknadsinformation','img/icons/newspaper-clipping.svg')}
                    
                                      
                </div>
            </div>

            <div className='mb-0'>
                {menuLink('/my-account/edit/', 'Inställningar', 'img/icons/cog.svg')}
                {Window.user_data.isAdmin && menuLink('/vb-admin/', 'Admin', 'img/icons/User-line.svg')}
                {menuLink('/logout/', 'Logga Ut', 'img/icons/logout.svg')}
            </div>
        </div>
    }

    const mobileQuickItem = (id, label, icon) => {
        return <div id={'quickmenu' + id} className={`col-3 d-flex flex-column align-items-center justify-content-center h-100 text-center ${navContext.view?.comp == id ? 'bg-supp-forest-green' : ''}`} onClick={() => {navContext.setView({comp: id}); setHistory(id)}}>
            <img src={`${Window.static_path}${icon}`} className={`${navContext.view?.comp == id ? 'white-filter' : 'neutral-charcoal-filter'}`} height='25px' width='25px' />
            <span className={`${navContext.view?.comp == id ? 'white' : 'neutral-charcoal'}`} style={{fontSize: '.7em'}}>{label}</span>
        </div>
    }

    const handleCreateAd = () => {
        if(createAdModal.done) {
            setCreateAdModal({show: false})
        } else {
            mixpanel.track('Clicked salj virke min skog');
            if(!createAdModal.type) {
                setCreateAdModal({...createAdModal, error: 'Du måste ange en åtgärd'})
            } else {
                setCreateAdModal({...createAdModal, loading: true})
                if(createAdModal.type == 'grot') {
                    setCreateAdModal({show: false})
                    window.open("/biobransle/", "_blank")
                } else {
                    let data = {
                        arrangement: createAdModal.type
                    }
                    if (createAdModal.type == "leveransvirke"){
                        data = {
                            arrangement: "slutavverkning",
                            type: "LEVERANSVIRKE"
                        }
                    }
                    createAd(data).then(resp => {
                        if(resp.ok) {
                            setCreateAdModal({...createAdModal, loading: false, done: true, title: <h2 className="mb-0 n-h5">Tack</h2>, message: <><p className='subtitle'>Vi återkommer till dig inom kort. </p><p className="subtitle">Du missar väl inte vår <a className="fw-bold" href="/kunskapscentrum/nyheter/">marknadsinformation</a></p></>})
                        } else {
                            setCreateAdModal({...createAdModal, loading: false, done: true, title: <h2 className="mb-0 n-h5">Oops, något gick fel.</h2>, message: <p className='subtitle'>Kontakta oss på <a className='fw-bold' href='mailto:info@treebula.se'>info@treebula.se</a> eller <a className='fw-bold' href='tel:00468339944'>08-33 99 44</a> så hjälper våra rådgivare dig att lösa detta så snabbt som möjligt.</p>})
                        }
                    })
                }
            }
        }
    }
    
    
    return <>
        <div className='d-flex align-items-center d-lg-none w-100 fixed-bottom bg-neutral-cloud p-0' style={{height: '80px', bottom: '-1px'}}>
            {mobileQuickItem('karta', 'Karta', 'img/icons/karta.svg')}
            {mobileQuickItem('overblick', 'Överblick', 'img/icons/overview.svg')}
            {/*mobileQuickItem('mina-annonser', 'Annonser', 'img/icons/item-list.svg')*/}
            <div className='col-3 d-flex flex-column align-items-center text-center' onClick={() => {setCreateAdModal({show: true});mixpanel.track("salja_virke_fe", { "source": "min-skog_main_nav" })}}>
                <img src={`${Window.static_path}img/icons/tree.svg`} height='25px' width='25px' />
                <span className={`neutral-pebble`} style={{fontSize: '.7em'}}>Sälj virke</span>
            </div>
            <div className='col-3 d-flex flex-column align-items-center text-center' onClick={() => setOffcanvas(true)}>
                <img src={`${Window.static_path}img/icons/hamburger.svg`} height='25px' width='25px' />
                <span className={`neutral-pebble`} style={{fontSize: '.7em'}}>Meny</span>
            </div>
        </div>

        <div className="d-none d-lg-block bg-neutral-cloud h-100 px-4" style={{width: "322px",overflowY: "auto"}}>
            {menuItems()}
        </div>

        <Offcanvas className="d-lg-none bg-neutral-cloud border-0 px-4 w-100" style={{overflowY: "auto"}} show={offcanvas} onHide={() => setOffcanvas(false)} backdrop={false} placement='start' closeButton>
            <img src={`${Window.static_path}img/icons/cross.svg`} onClick={() => setOffcanvas(false)} className='neutral-charcoal-filter position-absolute end-0 me-4 mt-4' height='30px' width='30px' />
            {menuItems()}
        </Offcanvas>

        {/* CREATE AD Modal */}
        <Modal show={createAdModal.show} onHide={() => setCreateAdModal({show: false})} size="lg" contentClassName="bg-neutral-cloud neutral-charcoal p-2" centered>
            <Modal.Header className="align-items-start border-0" closeButton>
                <h2 className="mb-0 n-h5">{createAdModal.title ? createAdModal.title : 'Är det dags att avverka eller gallra?'}</h2>
            </Modal.Header>
            <Modal.Body className="py-0">
                {createAdModal.message ? createAdModal.message :
                <>  
                    <p className='subtitle'>Att sälja virke genom Treebula är <b>alltid kostnadsfritt</b> och ger dig i snitt <b>23% högre virkespriser.</b> Vi kopplar samman dig med alla potentiella virkesköpare för att säkerställa högst värde för ditt virke</p>
                    <p className='subtitle'>Du <b>binder dig inte till något,</b> du får anbud av intresserade köpare och bestämmer själv om du vill sälja. Om du inte är nöjd tackar du enkelt nej.</p>
                    <p className='subtitle'>Välj vilken åtgärd det är det dags för nedan. Vi återkommer till dig inom kort med vilken ytterligare information vi behöver</p>

                    <VBDropdown
                        inputStyle={{minHeight: 0}} 
                        label={<label>Vilken åtgärd är det dags för?</label>}
                        onChange={(val) => setCreateAdModal({...createAdModal, type: val.value})}
                        error={createAdModal.error}
                        options={[{label: "Slutavverkning", value: "slutavverkning"}, {label: "Gallring", value: "gallring"}, {label: "Biobränsle eller GROT", value: "grot"}, {label:"Sälja leveransvirke", value:"leveransvirke"}]}
                        inputMode='none' />
                </>}
            </Modal.Body>
            <Modal.Footer className={`${!createAdModal.done ? 'justify-content-between' : 'justify-content-end'} border-0`}>
                {!createAdModal.done && <button type="button" className="n-btn btn-forest-green btn-sm" onClick={() => setCreateAdModal({show: false})}>Stäng</button>}
                <button type="button" className="n-btn btn-core btn-sm" onClick={() => !createAdModal.loading && handleCreateAd()}>{createAdModal.loading ? <Spinner animation="border" size="sm" /> : createAdModal.done ? 'Stäng' : 'Gå vidare'}</button>
            </Modal.Footer>
        </Modal>
        <ArbonicsDialog visible={arbonicsDialogVisible} hide={()=>{setArbonicsDialogVisible(false)}}/>
        {/* <ArbonicsModal visible={arbonicsDialogVisible} hide={() => {setArbonicsDialogVisible(false)}} /> */}
    </>
}